import { Directive, Input } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class RegisterProductBaseComponent extends BaseComponent {
  public loading: boolean = false;
  public selectedType: "software" | "hardware" | "guitar" = "guitar";
  public selectedOptionCardAssetId: number;
  @Input() productKey: string = "";
  public loadingRegister: boolean = false;

  constructor(userService: UserService) {
    super(userService);
  }
}
